import type { CSSProperties, ReactNode } from "react";
import type { SortDir } from "../lib/useSortable";

/** 可点击排序的表头单元格。当前列显示 ▲/▼，其余列 hover 显示淡灰指示。 */
export function SortableTh({ sortKey, active, dir, toggle, children, style }: {
  sortKey: string;
  active: string | null;
  dir: SortDir;
  toggle: (k: string) => void;
  children: ReactNode;
  style?: CSSProperties;
}) {
  const on = active === sortKey;
  return (
    <th className={`th-sort${on ? " is-active" : ""}`} style={style} onClick={() => toggle(sortKey)}>
      <span className="th-sort-inner">
        {children}
        <span className="th-sort-arrow">{on ? (dir === "asc" ? "▲" : "▼") : "⇅"}</span>
      </span>
    </th>
  );
}
